<app-top-menu></app-top-menu>
<div class="container" style="min-height: 62vh">
    <div class="bg-white">
        <div class="reports-heading mb-3 mt-2 px-3">
            <div class="ms-1 top-bar-div">
                <div class="mt-3">
                    <h6>ASIN Search</h6>
                </div>
            </div>

            <div class="right-buttons mt-3">
                <div
                        ngbDropdown
                        class="dropdown"
                        *ngIf="countDetails || details?.length > 0"
                >
                </div>
            </div>
        </div>

        <div class="search-parameters">
        </div>
        <form class="search-form" [formGroup]="searchForm">
            <div class="row">


                <div class="col-md-3">
                    <label>Phone No./NIN/Email/ASIN</label>
                    <input type="text" class="form-control small-option-font" formControlName="phone" placeholder="Enter Taxpayer phone number"/>
                </div>
                <div class="col-md-3">
                    <button class="btn btn-sm search-button small-option-font pointer" (click)="search()" type="submit">
                        <b *ngIf="!isLoading">Search</b>
                        <b *ngIf="isLoading"  class="spinner-border text-dark"></b>
                    </button>
                </div>
                <div class="col-md-3">
                    <button class="btn btn-sm reset-button small-option-font" (click)="resetForm()" type="submit">
                        Reset
                    </button>
                </div>
            </div>
        </form>

        <!-- <div class="table-responsive"> -->
        <table

                class="table table-striped table-hover table-bordered"
        >
            <thead class="table-dark">
            <tr>
                <th scope="col" class="assess-table-head">Photo</th>
                <th scope="col" class="assess-table-head">ASIN</th>
                <th scope="col" class="assess-table-head">NAME</th>
                <th scope="col" class="assess-table-head">EMAIL</th>
            </tr>
            </thead>

            <tbody>
            <tr>
                <td>
                    <div *ngIf="details?.photo">
                        <img src="{{ details?.photo }}"
                             style="width: 50px; height: 50px; border-radius: 50%; object-fit: cover;" />
                    </div>
                    <div *ngIf="!details?.photo" class="m-3">
                        <b class="rounded-xlg">
                            {{ details?.displayname?.split(' ')[0][0] }}{{
                                details?.displayname?.split('')[1][0] }}
                        </b>
                    </div>
                </td>
                <td>{{ details?.tinNumber }}</td>
                <td>{{ details?.displayname }}</td>
                <td>{{ details?.email }}</td>
            </tr>
            </tbody>
        </table>
        <div
                class="d-flex justify-content-center mt-3"
                *ngIf="selectedOutput == 'countValue'"
        >
            <p *ngIf="isSearching" class="text-muted">Please wait...</p>
        </div>

        <div
                class="d-flex justify-content-center mt-2 mb-5"
                *ngIf="searchInstruction"
        >
            <p class="text-muted">Please perform a search to view data.</p>
        </div>
    </div>
</div>

<app-footer></app-footer>
